module.exports = __webpack_public_path__ + "static/media/RL_LL_CHICA.deb8677b.webp";